export default class FailedInjection {
    /** @type {string} */
    id;
    /** @type {string} */
    name;

    /**
     * @param {string} id
     * @param {string} name
     */
    constructor(id, name) {
        this.id = id;
        this.name = name
    }

    /**
     * @param json
     * @returns {FailedInjection}
     */
    static parseServerJson(json){
        return new FailedInjection(json.id, json.name)
    }

    /**
     * @param json
     * @returns {FailedInjection[]}
     */
    static parseServerJsonMany(json) {
        if (!json)
            return []
        return json.map(j => (FailedInjection.parseServerJson(j)));
    }
}